<template>
  <div class="jr-tooltip">
    <template v-if="type === 'tooltip'">
      <el-tooltip effect="dark" placement="top" :disabled="disabled">
        <div slot="content" class="tooltip">{{ content }}</div>
        <div ref="textBox" class="table-title">
          <span ref="spanBox">{{ content }}</span>
        </div>
      </el-tooltip>
    </template>
    <template v-if="type === 'popover'">
      <el-popover
        placement="top-start"
        width="auto"
        trigger="hover"
        popper-class="popover-list"
        :disabled="disabled && !isFilter"
      >
        <div>
          <span
            v-for="(item, index) in handleContent(content)"
            :key="index"
            @dblclick="$copyMessage(item)"
            class="tag-box"
          >
            <el-tag class="popover-tag">{{item}}</el-tag>
            <!-- <span v-if="index < handleContent(content).length-1">,</span> -->
            <br v-if="(index + 1) % 3 === 0" />
          </span>
          <el-button type="text" v-if="isTooltipLimit && this.tagList.length > this.tooltipLimit" @click="handleCopy">复制全部</el-button>
        </div>
        <div ref="textBox" slot="reference" v-if="isFilter">
          <span ref="spanBox">{{ filterText(content)}}</span>
        </div>
        <div ref="textBox" class="table-title" slot="reference" v-else>
          <span ref="spanBox">{{ content || '-' }}</span>
        </div>
      </el-popover>
    </template>
  </div>
</template>
<script>
export default {
  name: 'TableTooltip',
  props: {
    // 文本内容
    content: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'tooltip',
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterTextNumber: {
      type: Number,
      default: 40,
    },
    isTooltipLimit: {
      type: Boolean,
      default: true,
    },
    tooltipLimit: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      disabled: true, // tooltip是否可用
    };
  },
  computed: {
    tagList() {
      if (!this.content) {
        return [];
      }
      const list = this.content.split(',') || [];
      return list;
    },
  },
  updated() {
    this.$nextTick(() => {
      // 判断是否启用tooltip
      this.disabled = this.$refs.spanBox.offsetWidth < this.$refs.textBox.offsetWidth;
    });
  },
  methods: {
    // 文字过滤
    filterText(val) {
      if (!val) {
        return '-';
      }
      const str = val.length > this.filterTextNumber ? `${val.substring(0, this.filterTextNumber)}...` : val;
      return str || '-';
    },
    // 展示相关处理
    handleContent(content) {
      if (!content) {
        return [];
      }
      const list = content.split(',') || [];
      if (this.isTooltipLimit) {
        return list.slice(0, this.tooltipLimit);
      }
      return list;
    },
    // 复制全部
    handleCopy() {
      const content = (this.content.split(',')).join('\n');
      this.$copyMessage(content, '复制成功');
    },
  },
};
</script>
<style lang="scss">
// 文本内容样式
.table-title {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  vertical-align: middle;
  line-height: 21px;
  font-size: 14px;
}

// tooltip组件样式
.tooltip {
  max-width: 200px;
}

.el-popover.popover-list {
  padding: 8px 16px;
  .tag-box {
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
    .popover-tag {
      min-width: 116px;
      text-align: center;
    }
  }
}
</style>
